var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinholder",style:({ width: _vm.width, height: _vm.height })},[_c('div',{staticClass:"spinit"},[_c('div',{style:({ width: _vm.width, height: _vm.height, 'border-thickness': _vm.thickness })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }